import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import CasesTableContainer from 'src/ui/features/Cases/containers/CasesTableContainer';
import AddCaseDrawer from '../components/AddCaseDrawer/AddCaseDrawer';
import { getCaseLookupValuesAPI, addCasesToDocumentAPI } from 'src/services/documents.service';
import { showNotification } from 'src/utils/utilsActions';
import intl from 'react-intl-universal';

class DocumentCasesContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isAddCaseOpen: false,
      isAddingCase: false,
      isLoadingCases: false,
      caseLookupValues: [],
      selectedCases: [],
    };

    this.toggleCaseDrawer = this.toggleCaseDrawer.bind(this);
    this.addCase = this.addCase.bind(this);
    this.getCaseLookupValues();
  }

  getCaseLookupValues = () => {
    const { documentId } = this.props.match.params;

    this.setState({ isLoadingCases: true });
    getCaseLookupValuesAPI(documentId).then(res => {
      if (res && !res.error && !res.errors) {
        this.setState({ caseLookupValues: res });
      } else {
        showNotification(intl.get('documents.notifications.fetchCasesError'), { variant: 'error' });
      }
      this.setState({ isLoadingCases: false });
    });
  };

  toggleCaseDrawer = () => {
    const currentState = this.state.isAddCaseOpen;

    // Get case lookup values if opening
    if (currentState === false) {
      this.getCaseLookupValues();
    }

    this.setState({ isAddCaseOpen: !currentState });
  };

  addCase = caseId => {
    const { selectedCases } = this.state;

    if (!selectedCases || !selectedCases.length) {
      this.setState({ isAddCaseOpen: false, isAddingCase: false, selectedCases: [] });
    }

    const { documentId } = this.props.match.params;
    const cases = selectedCases.map(c => ({ id: c.value, name: c.label }));

    this.setState({ isAddingCase: true });
    addCasesToDocumentAPI(documentId, cases).then(res => {
      if (res && res.errors && res.error) {
        showNotification(intl.get('documents.notifications.addCasesError'), { variant: 'error' });
      }
      this.setState({ isAddCaseOpen: false, isAddingCase: false, selectedCases: [] });
    });
  };

  handleCaseSelect = selectedCases => {
    this.setState({
      selectedCases,
    });
  };

  render() {
    const { documentId } = this.props.match.params;
    const { history } = this.props;
    return (
      <Fragment>
        <CasesTableContainer
          history={history}
          hideLandingHeader={true}
          isDocument
          addCaseAction={this.toggleCaseDrawer}
          defaultFilterValues={{
            caseStatusType: 'All',
            sortColumn: 'targetDate',
            documentId,
          }}
        />
        <AddCaseDrawer
          documentId={documentId}
          open={this.state.isAddCaseOpen}
          onClose={this.addCase}
          caseLookupValues={this.state.caseLookupValues}
          selectedCases={this.state.selectedCases}
          onCaseSelect={this.handleCaseSelect}
          isAddingCase={this.state.isAddingCase}
          isLoadingCases={this.state.isLoadingCases}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentCasesContainer);
